export const themeColors = {
  white: {
    palette: {
      type: "light",
      primary: {
        main: "#ffffff",
        contrastText: "rgba(0,0,0,.87)"
      },
      secondary: {
        main: "#FFA06A"
      }
    }
  },
  slateDark1: {
    palette: {
      type: "dark",
      primary: {
        main: "#222A45",
        contrastText: "#ffffff"
      },
      secondary: {
        main: "#FFA06A"
      },
      background: {
        paper: "#222A45",
        default: "#307FE2"
      }
    }
  },
  slateDark2: {
    palette: {
      type: "dark",
      primary: {
        main: "#307FE2",
        contrastText: "#ffffff"
      },
      secondary: {
        main: "#FFA06A"
      },
      background: {
        paper: "#222A45",
        default: "#307FE2"
      }
    }
  },
  purple1: {
    palette: {
      type: "light",
      primary: {
        main: "#307FE2",
        contrastText: "#ffffff"
      },
      secondary: {
        main: "#FFA06A"
      }
    }
  },
  purple2: {
    palette: {
      type: "light",
      primary: {
        main: "#6a75c9",
        contrastText: "#ffffff"
      },
      secondary: {
        main: "#FFA06A"
      }
    }
  },
  purpleDark1: {
    palette: {
      type: "dark",
      primary: {
        main: "#307FE2",
        contrastText: "#ffffff"
      },
      secondary: {
        main: "#FFA06A"
      },
      background: {
        paper: "#222A45",
        default: "#307FE2"
      }
    }
  },
  purpleDark2: {
    palette: {
      type: "dark",
      primary: {
        main: "#6a75c9",
        contrastText: "#ffffff"
      },
      secondary: {
        main: "#FFA06A"
      },
      background: {
        paper: "#222A45",
        default: "#307FE2"
      }
    }
  },
  blue: {
    palette: {
      type: "light",
      primary: {
        main: "#3366FF",
        contrastText: "#ffffff"
      },
      secondary: {
        main: "#FFAF38",
        contrastText: "#ffffff"
      }
    }
  },
  blueDark: {
    palette: {
      type: "dark",
      primary: {
        main: "#3366FF",
        contrastText: "#ffffff"
      },
      secondary: {
        main: "#FF4F30",
        contrastText: "#ffffff"
      },
      background: {
        paper: "#222A45",
        default: "#307FE2"
      }
    }
  }
};
